import React from "react";
import { UserEventPayoutCellTemplate } from "themes/common/components/producer";

function UserEventPayoutCell(props) {
    return <UserEventPayoutCellTemplate {...props} />;
}

export default UserEventPayoutCell;
